module.exports = __webpack_public_path__ + "static/img/game-head-main.6180331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-head-main.png
// module id = u0wQ
// module chunks = 1